"use client";

import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { stack } from "styled-system/patterns";

export interface DetailsEmptyTradesProps {
  lockCountdown?: string | null;
}

export function DetailsEmptyTrades({ lockCountdown }: DetailsEmptyTradesProps) {
  const t = useTranslations("firstTradeOnUs.empty");
  const tDashboard = useTranslations("firstTradeOnUs");

  return (
    <div className={containerStyles} data-testid="fft-details-empty-trades">
      <h3 className={titleStyles}>{t("title")}</h3>
      <p className={taglineStyles}>{t("tagline")}</p>
      {lockCountdown && (
        <p className={countdownStyles} data-testid="fft-empty-trades-countdown">
          {tDashboard("timeRemaining", { time: lockCountdown })}
        </p>
      )}
    </div>
  );
}

const containerStyles = stack({
  align: "center",
  justify: "center",
  gap: "8",
  py: "48",
  px: "16",
  w: "full",
  flex: "1",
});

const titleStyles = css({
  textStyle: "subheading.md",
  color: "text.primary",
  textAlign: "center",
});

const taglineStyles = css({
  textStyle: "body.md",
  color: "text.tertiary",
  textAlign: "center",
  maxW: "[440px]",
});

const countdownStyles = css({ mt: "8", textStyle: "body.md", color: "tag.text.gold" });
